import { render, staticRenderFns } from "./CheckboxesGrid.vue?vue&type=template&id=ebd1f5c0&"
import script from "./CheckboxesGrid.vue?vue&type=script&lang=js&"
export * from "./CheckboxesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports